module.exports = __webpack_public_path__ + "img/maya-1-analitico.48cf9b18.png";